export const CommonConstants = {
    imageBasePath: '../../../assets/images/'
}